import React from 'react'

const BrandGrid = () => {

  const importAll = (r) => {
    let images = {};
    r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  };
  
  const images = importAll(require.context('./images', false, /\.(png|jpe?g|svg|webp)$/))


  return (
    <div className='brandGrid'>
      {Object.keys(images).map((imageName, index) => (
        <img key={index} src={images[imageName]} alt={imageName} />
      ))}
    </div>
  )
}

export default BrandGrid